export const NECESSARY_COOKIES_ID = "C0001";
export const SITE_ANALYTICS_COOKIES_ID = "C0002";
export const CUSTOMER_PREFERENCES_COOKIES_ID = "C0003";
export const TARGETING_AND_ADVERTISING_COOKIES_ID = "C0004";
export const SOCIAL_MEDIA_COOKIES_ID = "C0005";

export const DEFAULT_CONSENT = {
  [NECESSARY_COOKIES_ID]: true,
  [SITE_ANALYTICS_COOKIES_ID]: false,
  [CUSTOMER_PREFERENCES_COOKIES_ID]: false,
  [TARGETING_AND_ADVERTISING_COOKIES_ID]: false,
  [SOCIAL_MEDIA_COOKIES_ID]: false
};

export const ONE_TRUST_ACTIVE_GROUPS_NAMESPACE = "OnetrustActiveGroups";
export const ONE_TRUST_COOKIE_NAME = "OptanonConsent";
export const ONE_TRUST_COOKIE_GROUPS_CATEGORY = "groups";
